function sleep (ms)
{
    return new Promise(resolve => setTimeout(resolve, ms));
}

export default { sleep }


// WEBPACK FOOTER //
// ./src/utils/asyncUtils.js